import { selectTreatmentValue } from '@splitsoftware/splitio-redux'
import { createSelector } from '@reduxjs/toolkit'
import { ReduxState } from 'reducers/root.reducer'

export const selectFeatureFlags = (state: ReduxState) => state.featureFlags
export const selectFeatureFlag = (featureFlag: string) =>
  createSelector(selectFeatureFlags, (featureFlags) => selectTreatmentValue(featureFlags, featureFlag))
export const selectFeatureFlagEnabled = (featureFlag: string) =>
  createSelector(selectFeatureFlags, (featureFlags) => selectTreatmentValue(featureFlags, featureFlag) === 'on')
